export default __webpack_public_path__ + "static/media/poker_banner.3842f3ce.jpg";